import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'wordifyFormatter',
     
})
export class WordifyPipe implements PipeTransform {
  transform(value: string): any {
    if (!value) {
      return '';
    }

    const result = value.replace(/([A-Z])/g, ' $1');

    return result;
  }
}
